import { SVGProps, memo } from 'react'
import ErrorCircleXSvg from 'src/components/icons/ErrorCircleX.svg'

const ErrorCircleX = memo<SVGProps<SVGSVGElement>>(props => <ErrorCircleXSvg {...props} />)

export default ErrorCircleX
